import { api } from "../../../utils/api";

export const filterAdjustment = async (data) => {
  if (data.type === true) {
    data.type_readjust = "monthly"
  } else {
    data.type_readjust = "annual"
  }
  try {
    const response = await api.get('sale/filter-readjust', {
      params: {
        enterprise_id: data.enterprise_id,
        month: data.mes,
        type: data.type_readjust
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
};
